module.exports = __webpack_public_path__ + "img/linse_bagt_closeup.612fb9e0.jpg";